<template>
    <div id="app">
        <div v-if="isLoading" class="loader-holder">
            <loader></loader>
        </div>
        <div v-else>
            <header-component></header-component>
            <main>
                <router-view></router-view>
            </main>
            <cookie-warning></cookie-warning>
        </div>
    </div>
</template>
<script>
  import HeaderComponent from '@/components/template/Header'
  import CookieWarning from '@/components/partials/CookieWarning'
  import Loader from '@/components/partials/Loader'
  import {mapGetters} from 'vuex'
  import DomainService from './services/DomainService'
  import store from './store'
  import config from './config'

  export default {
    name: 'app',
    components: {
      'header-component': HeaderComponent,
      'cookie-warning': CookieWarning,
      'loader': Loader,
    },
    methods: {
      loadWhiteLabelCSS (subdomain) {
        let file = document.createElement('link')
        file.rel = 'stylesheet'
        file.href = config.API_URL + 'whitelabel-css/' + subdomain + '.css'
        document.head.appendChild(file)
      }
    },
    mounted: function () {
      let subDomain = DomainService.getSubDomain()
      if (subDomain === '') {
        subDomain = 'ravi'
      }
      this.loadWhiteLabelCSS(subDomain)
      store.dispatch('customer/getCustomer', subDomain)
    },

    computed: mapGetters({
      customer: 'customer/getCustomer',
      customerConfigs: 'customer/getConfigs',
      isLoading: 'customer/isLoading',
    }),
  }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;400&display=swap');
    #app {
        font-family: 'Montserrat', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #fff;
    }

    #nav {
        padding: 30px;
        width: 100%;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
